export const deviceMinWidth = {
  size361: `@media (min-width: 361px)`,
  size501: `@media (min-width: 501px)`,
  size601: `@media (min-width: 601px)`, // *
  size769: `@media (min-width: 769px)`,
  size1025: `@media (min-width: 1025px)`,
  size1201: `@media (min-width: 1201px)`,
  size1301: `@media (min-width: 1301px)`, // *
  size1441: `@media (min-width: 1441px)`,
};

export const deviceMaxWidth = {
  size360: `@media (max-width: 360px)`,
  size500: `@media (max-width: 500px)`,
  size600: `@media (max-width: 600px)`, // *
  size768: `@media (max-width: 768px)`,
  size1024: `@media (max-width: 1024px)`,
  size1200: `@media (max-width: 1200px)`,
  size1300: `@media (max-width: 1300px)`, // *
  size1440: `@media (max-width: 1440px)`,
  size2560: `@media (max-width: 2560px)`,
};
